import API from '../API'

export default class LogoutAPI extends API {
  public logoutUser() {
    return this.get('api/auth/logout')
  }
}
